import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { ManoDeObra } from 'src/app/shared/models/mano-de-obra';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ManoDeObraCompuesta } from 'src/app/shared/models/mano-de-obra-compuesta';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DetalleManoObraCompuestaComponent } from '../detalle-mano-obra-compuesta/detalle-mano-obra-compuesta.component';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { Constanst } from 'src/app/core/constants/constans.component';

@Component({
  selector: 'app-gestion-mano-obra-compuesta',
  templateUrl: './gestion-mano-obra-compuesta.component.html',
  styleUrls: ['./gestion-mano-obra-compuesta.component.css']
})
export class GestionManoObraCompuestaComponent implements OnInit {

  displayedColumns: string[] = ['reference', 'updateDate', 'description', 'jornal', 'price', 'addedValue',
    'laborGrouping'];
  displayedColumnsSimples: string[] = ['reference', 'description', 'quantity', 'jornal', 'bono', 'totalJornal',
  'totalBono'];

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  dataSourceFilters = new MatTableDataSource<ManoDeObra>;
  dataSourceSimples = new MatTableDataSource<ManoDeObra>;

  filterColumForm = new FormGroup({
    filterDetails: new FormControl('0'),
    descriptionFilter: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });
  filterSearchForm = new FormGroup({
    descriptionSearch: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });
  filterNoSelected: boolean = false;
  filterDictionary= new Map<string|null,string|null>();
  messageError: string;
  referenciaCompuesto: string = "(clic en tabla)";
  isVisibleDiv: boolean = true;

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  totalItemsPage: number;
  dataListManoDeObra: ManoDeObra[];
  disableButtonfilter: boolean = true;
  disableButtonSearch: boolean = false;
  typeAction: string;

  xpandDisabled = true;
  defaultFilterDetails = 'description';
  classFlag: boolean = false;

  constructor(
    private apiCallService: ApiCallService,
    public dialogDetalleManoObra: MatDialog,
    private helperClassService: HelperClassService
  ) { }

  ngOnInit(): void {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    this.filterColumForm.get('filterDetails')!.setValue(this.defaultFilterDetails);
    this.getAllLabor();
    this.cleanFilter();
  }

  getAllLabor() {
    this.route = '/getLaborForDatePage';
    this.method = 'POST';
    this.typeAction = 'filterAll';
    let data = {
      idTypeLabor: 2,
      year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
      month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
      page: (this.paginator ? (this.paginator.pageIndex) : 0),
      pageSize: (this.paginator ? this.paginator.pageSize : 25)
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {

        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          this.totalItemsPage = response.data.total;
          this.dataListManoDeObra = response.data.content;
          this.dataSourceFilters = new MatTableDataSource(this.dataListManoDeObra);
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
        this.apiCallService.hideSpinner();
      });
  }

  cleanFilter() {
    this.filterColumForm.get('descriptionFilter')?.setValue('');
    this.filterSearchForm.get('descriptionSearch')?.setValue('');
    if (this.filterColumForm.get('filterDetails')?.value === '0') {
      this.filterColumForm.get('descriptionFilter')?.disable();
      this.disableButtonfilter = true;
      this.filterSearchForm.get('descriptionSearch')?.enable();
      this.disableButtonSearch = false;
      this.paginator.pageIndex = 0;
      this.getAllLabor();
    } else {
      this.filterColumForm.get('descriptionFilter')?.enable();
      this.disableButtonfilter = false;
      this.filterSearchForm.get('descriptionSearch')?.disable();
      this.disableButtonSearch = true;
    }
  }

  ngAfterViewInit() {
    this.dataSourceFilters.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      if (this.typeAction == 'filterColum') {
        this.applyFilterDetails();
      } else if (this.typeAction == 'filterSearch') {
        this.applyFilter();
      } else {
        this.getAllLabor();
      }
    });
    this.dataSourceFilters.sort = this.sort;
  }

  applyFilterDetails() {
    if (this.filterColumForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterColum';
      let typeSearchValue = -1;
      let filterValue = this.filterColumForm.controls['descriptionFilter'].value;
      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          let typeSearch = this.filterColumForm.controls['filterDetails'].value;
          if (typeSearch === 'laborGrouping') { typeSearchValue = 0 }
          if (typeSearch === 'description') { typeSearchValue = 1 }
          if (typeSearch === 'reference') { typeSearchValue = 2 }

          this.route = '/getAllLaborCustomizedPage';
          this.method = 'POST';
          let data = {
            idTypeLabor: 2,
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            typeSearchLabor: typeSearchValue,
            searchLabor: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListManoDeObra = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListManoDeObra);
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            });
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  applyFilter() {
    if (this.filterSearchForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterSearch';
      let filterValue = this.filterSearchForm.controls['descriptionSearch'].value;
      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          this.route = '/getAllLaborGeneralPage';
          this.method = 'POST';
          let data = {
            idTypeLabor: 2,
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            searchLabor: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListManoDeObra = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListManoDeObra);
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            });
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  verManoObraSimple(row: ManoDeObra) {
    this.route = '/getAllLaborInOneCompoundById';
    this.method = 'POST';

    let data = {
      idCompoundLabor: row.idLabor
    }
    this.apiCallService.call$(data, this.route, this.method, true, '', false)
    .pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        //console.log(response);
        this.dataSourceSimples = new MatTableDataSource(response.data);
        this.dataSourceSimples = response.data;
        this.referenciaCompuesto = row.reference
        this.xpandDisabled = false;
        this.apiCallService.hideSpinner();
      }
    );
  }

  verDetalle(row: ManoDeObraCompuesta) {
    this.dialogDetalleManoObra.open(DetalleManoObraCompuestaComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      // disableClose: true,
      data: { row, nroRegistro: this.totalItemsPage, dialogTitle: 'Mano de Obra Compuesta' }
    });
  }

  hideDiv() {
    this.isVisibleDiv = false;
  }

  resetPaginator(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value.trim();
    if (filterValue == '') {
      this.paginator.pageIndex = 0;
      this.getAllLabor();
    }
  }

}
